export const DATA_HOOKS = {
  createdBy: 'createdBy',
};
